<template>
  <div class="petit pb-125">
    <div class="container pt-100">
      <div class="row pb-50">
        <div class="col-md-12 text-center mb-5">
          <h1 class="display-1 mt-8" id="main">Vous avez une question ?</h1>
          <h3 class="lead">
            Nos Horraires : 9h - 12h30 / 14h -17h30
          </h3>
        </div>
      </div>
      <div class="row pb-125">
        <div class="col-md-4">
          <div class="info info-hover">
            <div
              class="icon icon-shape icon-shape-anhod2 icon-lg shadow rounded-circle text-primary"
            >
              <i class="ni ni-square-pin" style="color: #222"></i>
            </div>
            <h4 class="info-title">Adresse</h4>
            <p class="description px-0">
              16 avenue Charles de Gaulle - 31130 BALMA
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info info-hover">
            <div
              class="icon icon-shape icon-shape-anhod2 icon-lg shadow rounded-circle text-primary"
            >
              <i class="ni ni-email-83" style="color: #222"></i>
            </div>
            <h4 class="info-title">Email</h4>
            <p class="description px-0">contentieux@arcos-solution.com</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info info-hover">
            <div
              class="icon icon-shape icon-shape-anhod2 icon-lg shadow rounded-circle text-primary"
            >
              <i class="ni ni-mobile-button" style="color: #222"></i>
            </div>
            <h4 class="info-title">Téléphone</h4>
            <p class="description px-0">+33 5 61 83 29 13</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { HTTP_REQUEST } from "../constants/constantes";
import router from "@/router";

export default {
  bodyClass: "contact-page",
  data() {
    return {};
  },
  created: function() {
    this.verifToken();
  },
  methods: {
    // Vérification du token existant
    verifToken: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          let action = "action=VuePaiement";
          let token = "&token=" + self.$store.state.tokens;
          var postData = action + token;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID") {
              self.$store.commit("removeToken", 0);
              self.$store.commit("removeSolde", 0);
              router.push("/login/1/0/0");
            } else if (retourApi.data == "INVALID PARAMS") {
              router.push("/login/1/0/0");
            }
          }
        });
      } else {
        router.push("/login/1/0/0");
      }
    }
  }
};
</script>
<style>
.petit {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
  background-attachment: fixed;
}
.info-title {
  font-size: 1.5em;
}
.description {
  font-size: 1.2em;
}
@media screen and (max-width: 940px) {
  #main {
    font-size: 2em;
  }
}
</style>
